var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBorussiaMnchengladbachLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M59.4 0 0 95.1 59.5 190 119 95.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4 6 3.8 95.1 59.5 184l55.7-88.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M59.4 20.4 12.8 95.1l46.7 74.5 46.7-74.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 27 16.9 95.1 59.5 163l42.6-67.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M59.5 32.3 20.2 95.1l39.3 62.6 39.3-62.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4 30.9 47.6 48.6h24zm21.3 95.8h-42L23 101.8h72.7zm-41.6-64h41l15 24.9H23.4zm20.3 97.5-12.2-19.6h25.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8 126.4h29.5c8.5 0 15.9-8.1 15.9-19.2 0-6.3-2.8-10.1-4.3-12.1 1.7-1.8 4.2-4.1 4.2-13 0-6.4-5.4-18.8-18-18.8H39.8v63.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M42 124.3h24.5c7.9 0 16.3-5.1 16.3-16.9 0-5.9-2.7-9.4-4.7-12.2C79.7 93.6 83 91 83 82.6c0-5.9-3.4-17.3-17.8-17.3H42v59z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1 122.2h20.7c9.1 0 15.9-4.8 15.9-15.7 0-5.4-3.8-10.2-5.7-11.3 1.7-1 5.9-3.9 5.9-11.7 0-6.2-3.3-16.1-16.7-16.1H44.1v54.8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M53.2 99.6h10.6c3.5 0 6.8 2 6.8 5.7 0 4.5-3.2 6-7.4 6h-9.9l-.1-11.7zm0-22h9.1c3 0 7.2.6 7.2 5.7 0 5.6-4 5.9-7.2 5.9h-9.1V77.6z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4 79.7H62c2.1 0 5.1.1 5.1 3.7 0 3.5-2.8 3.7-5.1 3.7h-6.6v-7.4zm.2 22h7.2c2.3 0 5.3 1.3 5.3 3.8 0 3.2-2.9 3.7-5.7 3.7h-6.8v-7.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorussiaMnchengladbachLogo);
export default __webpack_public_path__ + "static/media/Borussia_Mönchengladbach_logo.c0654212cd7dede7de35c48762b16500.svg";
export { ForwardRef as ReactComponent };